import type { LandingContent } from "./types";
import raw from "./content.en.json";

// EN is the source locale. In production, replace this module with your i18n
// hook (react-i18next / next-intl) returning the same LandingContent shape.
// The imported JSON carries helper keys (_note, _prices) that the type ignores.
export const en = raw as unknown as LandingContent;

// Minimal `useT`: returns the active-locale content object. Swap the body for
// your i18n lib; components read fields off the returned object (typed).
export function useContent(): LandingContent {
  return en;
}
